"use strict";

function Theme(application) {
  this.application = application || "EEN";
  this.mapping = {
    EEN: "een",
  };

  this.defaultColors = {
    //Fixed colors
    primary: "#252932",
    primaryMedium: "#2F3644",
    primaryLight: "#475268",
    primaryWhite: "#FFFFFF",
    secondary: "#606E81",
    secondaryMedium: "#8F9CAC",
    secondaryLight: "#BEC9D6",
    elements: "#E3E9EF",
    backgrounds: "#F3F7FB",

    //Action Colors
    positive: "#1fb67f",
    positiveDark: "#009660",
    positiveLight: "#A8E8D0",
    positiveClear: "#e7fff6",

    warning: "#E9B600",
    warningDark: "#d3a500",
    warningLight: "#F6E7B3",
    warningClear: "#fff9e4",

    negative: "#ee5361",
    negativeDark: "#d0404d",
    negativeLight: "#FFBFC6",
    negativeClear: "#fdeaec",
  };

  this.themes = {
    een: {
      colors: {
        accent: "#0091da",
        accentDark: "#0067AC",
        accentLight: "#C6E6FF",
        accentClear: "#E5F4FF",
      },
      companyName: "Eagle Eye Networks",
      favicon: "favicon.ico",
    },
  };
}

Theme.prototype.colors = function () {
  const mapping = this.mapping[this.application] ? this.mapping[this.application] : "een";
  const colors = {
    ...this.defaultColors,
    ...(this.themes[mapping] ? this.themes[mapping].colors : this.themes.een.colors),
  };
  return { themes: { light: colors }, options: { customProperties: true } };
};

Theme.prototype.logo = function (type = "") {
  const mapping = this.mapping[this.application] ? this.mapping[this.application] : "een";
  return this.themes[mapping]
    ? this.themes[mapping][`logo${type}`]
      ? this.themes[mapping][`logo${type}`]
      : null
    : null;
};

Theme.prototype.favicon = function (type = "") {
  const mapping = this.mapping[this.application] ? this.mapping[this.application] : "een";
  return this.themes[mapping]
    ? this.themes[mapping][`favicon${type}`]
      ? this.themes[mapping][`favicon${type}`]
      : null
    : null;
};

Theme.prototype.logoHeight = function (type = "") {
  const mapping = this.mapping[this.application] ? this.mapping[this.application] : "een";
  return this.themes[mapping]
    ? this.themes[mapping][`logoHeight${type}`]
      ? this.themes[mapping][`logoHeight${type}`]
      : null
    : null;
};

Theme.prototype.logoWidth = function (type = "") {
  const mapping = this.mapping[this.application] ? this.mapping[this.application] : "een";
  return this.themes[mapping]
    ? this.themes[mapping][`logoWidth${type}`]
      ? this.themes[mapping][`logoWidth${type}`]
      : null
    : null;
};

Theme.prototype.companyName = function (type = "") {
  const mapping = this.mapping[this.application] ? this.mapping[this.application] : "een";
  return this.themes[mapping]
    ? this.themes[mapping][`companyName${type}`]
      ? this.themes[mapping][`companyName${type}`]
      : null
    : null;
};
Theme.prototype.links = function (type = "") {
  const mapping = this.mapping[this.application] ? this.mapping[this.application] : "een";
  return this.themes[mapping]
    ? this.themes[mapping][`links${type}`]
      ? this.themes[mapping][`links${type}`]
      : null
    : null;
};

export default Theme;
